import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';
import { Common, useCommon } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';

const Wrapper = styled('div', { label: 'Wrapper' })`
    text-align: center;
    cursor: pointer;
`;

const TranslationLink = styled('span', { label: 'TranslationLink' })`
    padding: 10px;
    cursor: pointer;
    &:hover {
        background-color: #e0e0e0;
        color: red;
    }
`;

const renderButtonDot = (common: Common): React.ReactNode => {
    const languagesState = LanguagesState.get(common);

    if (languagesState.translationsDisplayDebug === 'show-dot') {
        return <TranslationLink onClick={languagesState.translationsDisplayDebugHide}>Hide dot</TranslationLink>;
    }

    return <TranslationLink onClick={languagesState.translationsDisplayDebugShowDot}>Show dot</TranslationLink>;
};

const renderButtonId = (common: Common): React.ReactNode => {
    const languagesState = LanguagesState.get(common);

    if (languagesState.translationsDisplayDebug === 'show-id') {
        return <TranslationLink onClick={languagesState.translationsDisplayDebugHide}>Hide id</TranslationLink>;
    }

    return <TranslationLink onClick={languagesState.translationsDisplayDebugShowId}>Show id</TranslationLink>;
};

export const MainViewTranslations = observer('MainViewTranslations', () => {
    const common = useCommon();
    return (
        <Wrapper>
            {renderButtonDot(common)}
            {renderButtonId(common)}
        </Wrapper>
    );
});
